import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../../withItemCache/WithItemCache';
import { SharedField } from '../../fields/sharedItem/SharedField';
import { sharedFieldClickActionControl } from '../../../controls/sharedFieldClickActionControl';
import { isSharedFacet } from '../../../facets/ItemFacets';
import { WithAction, IActionStateProps } from '../../withAction/WithAction';

export interface ISharedRendererProps {
    itemKey: string;
}

export class SharedRenderer extends React.PureComponent<ISharedRendererProps> {
    public render(): JSX.Element {
        const {
            itemKey,
        } = this.props;

        return (
            <WithItemCache>{ ({ itemCache }: IItemCacheStateProps): JSX.Element => {
                const controlHandler = itemCache.demandItemFacet(sharedFieldClickActionControl, itemKey);

                const {
                    onClickAction
                } = sharedFieldClickActionControl.evaluate(controlHandler)(itemCache, {
                    itemKey: itemKey
                });

                const shared = itemCache.demandItemFacet(isSharedFacet, itemKey);

                return (
                    <WithAction action={ onClickAction }>
                        { ({ execute, isAvailable }: IActionStateProps) => {
                            const onClick = isAvailable ? (ev: React.MouseEvent<HTMLElement>) => {
                                execute({
                                    event: ev
                                }).catch(() => {
                                    // Ignore errors.
                                });

                                ev.preventDefault();
                                ev.stopPropagation();
                            } : undefined;

                            return (
                                <SharedField
                                    shared={ shared }
                                    onClick={ onClick }
                                />
                            );
                        } }
                    </WithAction>
                );
            } }
            </WithItemCache>
        );
    }
}
